import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { Customer } from 'src/app/interfaces/customer';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConfigDataService } from 'src/app/services/config-data.service';
import { GeneralService } from 'src/app/services/general.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-billing-reports',
    templateUrl: './billing-reports.component.html',
    styleUrls: ['./billing-reports.component.scss'],
    standalone: false
})
export class BillingReportsComponent {
     companyType: string = '';

    customer?: Customer;
    userProfile?: UserProfile;



     constructor(public generalService: GeneralService,
          private authenticationService: AuthenticationService,public invoiceService: InvoiceService,
          public configDataService: ConfigDataService,
          private router: Router) {
          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
          this.customer = this.userProfile!.customer;
          this.companyType = this.customer.customerType === 1 ?
               'MC' :
               this.customer.customerType === 6 ?
                    'ISP' :
                    '';
          this.scrollToTop();
     }

     get CdbBillingReportsLink() {
          return environment?.APP_CDB_URL;
      }


     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }

     

     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
